export default __webpack_public_path__ + "static/media/property-main.92a58dbb.png";